import { version } from '../../package.json';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: version,
  clientId: '2',
  apiPrefix: 'v1',
  masterPassword: '@Satturno2024',

  // apiUrl: 'http://localhost:8080',
  // storageUrl: 'http://localhost:8080/storage',
  // clientSecret: '8JOppCNP1VS4zNASLRVho8HVT16VCtXzDawl390P',
  // socUrl: 'http://localhost:6001',
  // googleMapsKey: 'AIzaSyBY6qTM6bHCFbCoiZ6HMuPVS1n4NoHQRi0',

  apiUrl: 'https://dev.api.atendimento.satturno.com.br',
  storageUrl: 'https://dev.api.atendimento.satturno.com.br/storage',
  clientSecret: 'n0ZXgZTZxRx5IAun2QvEgMn8mclm3ZHYSxS2FTr8',
  socUrl: 'https://dev.soc.atendimento.satturno.com.br',
  googleMapsKey: 'AIzaSyBY6qTM6bHCFbCoiZ6HMuPVS1n4NoHQRi0',

  // apiUrl: 'https://api.atendimento.satturno.com.br',
  // storageUrl: 'https://api.atendimento.satturno.com.br/storage',
  // clientSecret: 'BAjkzMZoBUPu9diceTcy5mmfhmnC8irLSNcfTbNO',
  // socUrl: 'https://soc.atendimento.satturno.com.br',
  // googleMapsKey: 'AIzaSyBY6qTM6bHCFbCoiZ6HMuPVS1n4NoHQRi0',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
